<template>
  <div class="articles-div my-8">
    <div class="container">
      <div class="_title">
        <div class="label-div">
          <i class="mdi mdi-circle"></i>&nbsp;
          المقالات
        </div>
        <h1>اكتشف عالم التصوير في مدونتنا</h1>
      </div>

      <section class="photo-grid">
        <div v-for="i in 5" :key="i" class="photo-card" :class="(i === 1 ? 'large' : '')">
          <img src="/img/newMainPage/header-bg2.png" alt="Studio Photo"/>
          <div class="photo-info">
            <span class="photo-date">الأثنين • 31 يناير 2025</span>
            <h3>مساحات تصوير مبتكرة: خيارات متعددة لتحقيق نتائج مبهرة</h3>
          </div>
        </div>
      </section>


      <div class="text-center mt-8">
        <a href="#" target="_blank" class="btn btn-dark slider-btn">
          {{ $t("all-articles") }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["homeSetting", "siteData"],
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
._title {
  margin-bottom: 35px;

  h1 {
    color: #000;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 48px;
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 24px;
      line-height: 32px;
    }
  }
}

.slider-btn {
  border: 1px solid #1E1E1E;
  min-width: 230px;
  padding: 12px 0;
  border-radius: 8px;
  background: #1E1E1E;
  color: #FFF;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  box-shadow: 0 1px 2px 0 rgba(13, 13, 18, 0.06);
}

@media (max-width: 768px) {
  .slider-btn {
    font-size: 14px;
    font-weight: 500;
    min-width: 150px;
    padding: 10px 0;
  }
}
</style>
<style scoped>
.photo-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin: 0 auto;
}

.photo-card {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  background: #f7f7f7;
}

.photo-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  border-radius: 16px;
  transition: transform 0.4s ease;
}

.photo-card:hover img {
  transform: scale(1.05);
}

.photo-info {
  position: absolute;
  bottom: 10px;
  right: 10px;
  left: 10px;
  background: rgba(255, 255, 255, 0.96);
  border-radius: 10px;
  padding: 10px 15px;
  text-align: right;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.photo-info .photo-date {
  display: block;
  font-size: 12px;
  color: #727272;
  margin-bottom: 4px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
}

.photo-info h3 {
  font-size: 16px;
  color: #000;
  line-height: 24px;
  margin: 0;
  font-style: normal;
  font-weight: 600;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* limit to 2 lines */
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.photo-card.large {
  grid-column: span 2;
  grid-row: span 2;
}

.photo-card.large h3 {
  font-size: 24px;
  line-height: 32px;
}

.photo-card.large .photo-date {
  font-size: 14px;
  line-height: 20px;
}

@media (max-width: 767px) {
  .photo-grid {
    display: block;
  }

  .photo-card {
    margin-bottom: 16px;
    border-radius: 20px;
  }

  .photo-card img {
    border-radius: 20px;
    max-height: 350px;
  }

  .photo-info {
    border-radius: 16px;
    padding: 12px;
  }

  .photo-card.large h3 {
    font-size: 16px;
    line-height: 24px;
  }

  .photo-card.large .photo-date {
    font-size: 12px;
    line-height: 16px;
  }
}
</style>